var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "container" },
    [
      _c(
        "a-modal",
        {
          staticStyle: { top: "100px" },
          attrs: {
            title: _vm.title,
            width: 520,
            visible: _vm.visible,
            confirmLoading: _vm.confirmLoading,
            getContainer: () => _vm.$refs.container,
            maskStyle: { top: "93px", left: "154px" },
            mask: _vm.isDesktop(),
            maskClosable: false,
            cancelText: "取消",
            okText: "保存",
          },
          on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
        },
        [
          _c(
            "a-spin",
            { attrs: { spinning: _vm.confirmLoading } },
            [
              _c(
                "a-form",
                { attrs: { form: _vm.form } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: "桌台名称",
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator.trim",
                            value: ["name", _vm.validatorRules.name],
                            expression: "['name', validatorRules.name]",
                            modifiers: { trim: true },
                          },
                        ],
                        attrs: { placeholder: "如：A01" },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: "所属区域",
                      },
                    },
                    [
                      _c(
                        "a-select",
                        {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: ["areaId", _vm.validatorRules.areaId],
                              expression: "['areaId', validatorRules.areaId]",
                            },
                          ],
                          attrs: { placeholder: "请选择区域" },
                        },
                        _vm._l(_vm.areas, function (a) {
                          return _c(
                            "a-select-option",
                            { key: a.id, attrs: { value: a.id } },
                            [_vm._v(_vm._s(a.name))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: "桌型",
                      },
                    },
                    [
                      _c(
                        "a-select",
                        {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: ["tableTypeId"],
                              expression: "['tableTypeId']",
                            },
                          ],
                          attrs: {
                            placeholder: "请选择桌型（可不选）",
                            "allow-clear": "",
                          },
                        },
                        _vm._l(_vm.types, function (t) {
                          return _c(
                            "a-select-option",
                            { key: t.id, attrs: { value: t.id } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(t.name) +
                                  "（" +
                                  _vm._s(t.minCapacity) +
                                  "-" +
                                  _vm._s(t.maxCapacity) +
                                  "人）\n            "
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: "可坐人数",
                      },
                    },
                    [
                      _c("a-input-number", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["capacity", { initialValue: 4 }],
                            expression: "['capacity', { initialValue: 4 }]",
                          },
                        ],
                        staticStyle: { width: "100%" },
                        attrs: { min: 1, placeholder: "默认 4 人" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }